import { PartialType } from '@nestjs/swagger';
import { CrearReglaPrecioDto } from './crear-regla-precio.dto';

export class ActualizarReglaPrecioDto extends PartialType(CrearReglaPrecioDto) {}
